// 国家相关

// 目前可以提供服务的国家
export const supportServiceCountryList = [
  { value: "Singapore", zh: "新加坡", en: "Singapore", componentName: "SingaporeForm" },
  { value: "Malaysia", zh: "马来西亚", en: "Malaysia", componentName: "MalaysiaForm" },
  // { value: "Virgin Islands, British", zh: "英属维尔京群岛", en: "Virgin Islands, British", componentName: "BviForm" },
  // { value: "Cayman Islands", zh: "开曼群岛", en: "Cayman Islands", componentName: "CaymanForm" },
];
// 全部国家
export const countryList = [
  {
    value: "Singapore",
    zh: "Singapore 新加坡",
    en: "Singapore",
  },
  {
    value: "Malaysia",
    zh: "Malaysia 马来西亚",
    en: "Malaysia",
  },
  {
    value: "China",
    zh: "China 中国",
    en: "China",
  },
  {
    value: "Hong Kong",
    zh: "Hong Kong 香港",
    en: "Hong Kong",
  },
  {
    value: "Afghanistan",
    zh: "Afghanistan",
    en: "Afghanistan",
  },
  {
    value: "Albania",
    zh: "Albania",
    en: "Albania",
  },
  {
    value: "Algeria",
    zh: "Algeria",
    en: "Algeria",
  },
  {
    value: "American Samoa",
    zh: "American Samoa",
    en: "American Samoa",
  },
  {
    value: "Andorra",
    zh: "Andorra",
    en: "Andorra",
  },
  {
    value: "Angola",
    zh: "Angola",
    en: "Angola",
  },
  {
    value: "Anguilla",
    zh: "Anguilla",
    en: "Anguilla",
  },
  {
    value: "Antarctica",
    zh: "Antarctica",
    en: "Antarctica",
  },
  {
    value: "Antigua and Barbuda",
    zh: "Antigua and Barbuda",
    en: "Antigua and Barbuda",
  },
  {
    value: "Argentina",
    zh: "Argentina",
    en: "Argentina",
  },
  {
    value: "Armenia",
    zh: "Armenia",
    en: "Armenia",
  },
  {
    value: "Aruba",
    zh: "Aruba",
    en: "Aruba",
  },
  {
    value: "Australia",
    zh: "Australia",
    en: "Australia",
  },
  {
    value: "Austria",
    zh: "Austria",
    en: "Austria",
  },
  {
    value: "Azerbaijan",
    zh: "Azerbaijan",
    en: "Azerbaijan",
  },
  {
    value: "Bahamas",
    zh: "Bahamas",
    en: "Bahamas",
  },
  {
    value: "Bahrain",
    zh: "Bahrain",
    en: "Bahrain",
  },
  {
    value: "Bangladesh",
    zh: "Bangladesh",
    en: "Bangladesh",
  },
  {
    value: "Barbados",
    zh: "Barbados",
    en: "Barbados",
  },
  {
    value: "Belarus",
    zh: "Belarus",
    en: "Belarus",
  },
  {
    value: "Belgium",
    zh: "Belgium",
    en: "Belgium",
  },
  {
    value: "Belize",
    zh: "Belize",
    en: "Belize",
  },
  {
    value: "Benin",
    zh: "Benin",
    en: "Benin",
  },
  {
    value: "Bermuda",
    zh: "Bermuda",
    en: "Bermuda",
  },
  {
    value: "Bhutan",
    zh: "Bhutan",
    en: "Bhutan",
  },
  {
    value: "Bolivia",
    zh: "Bolivia",
    en: "Bolivia",
  },
  {
    value: "Bonaire Sint Eustatius And Saba",
    zh: "Bonaire Sint Eustatius And Saba",
    en: "Bonaire Sint Eustatius And Saba",
  },
  {
    value: "Bosnia and Herzegovina",
    zh: "Bosnia and Herzegovina",
    en: "Bosnia and Herzegovina",
  },
  {
    value: "Botswana",
    zh: "Botswana",
    en: "Botswana",
  },
  {
    value: "Bouvet Island",
    zh: "Bouvet Island",
    en: "Bouvet Island",
  },
  {
    value: "Brazil",
    zh: "Brazil",
    en: "Brazil",
  },
  {
    value: "British Indian Ocean Territory",
    zh: "British Indian Ocean Territory",
    en: "British Indian Ocean Territory",
  },
  {
    value: "Brunei Darussalam",
    zh: "Brunei Darussalam",
    en: "Brunei Darussalam",
  },
  {
    value: "Bulgaria",
    zh: "Bulgaria",
    en: "Bulgaria",
  },
  {
    value: "Burkina Faso",
    zh: "Burkina Faso",
    en: "Burkina Faso",
  },
  {
    value: "Burundi",
    zh: "Burundi",
    en: "Burundi",
  },
  {
    value: "Cabo Verde",
    zh: "Cabo Verde",
    en: "Cabo Verde",
  },
  {
    value: "Cambodia",
    zh: "Cambodia",
    en: "Cambodia",
  },
  {
    value: "Cameroon",
    zh: "Cameroon",
    en: "Cameroon",
  },
  {
    value: "Canada",
    zh: "Canada",
    en: "Canada",
  },
  {
    value: "Cayman Islands",
    zh: "Cayman Islands",
    en: "Cayman Islands",
  },
  {
    value: "Central African Republic",
    zh: "Central African Republic",
    en: "Central African Republic",
  },
  {
    value: "Chad",
    zh: "Chad",
    en: "Chad",
  },
  {
    value: "Chile",
    zh: "Chile",
    en: "Chile",
  },
  {
    value: "Christmas Island",
    zh: "Christmas Island",
    en: "Christmas Island",
  },
  {
    value: "Cocos (Keeling) Islands",
    zh: "Cocos (Keeling) Islands",
    en: "Cocos (Keeling) Islands",
  },
  {
    value: "Colombia",
    zh: "Colombia",
    en: "Colombia",
  },
  {
    value: "Comoros",
    zh: "Comoros",
    en: "Comoros",
  },
  {
    value: "Congo",
    zh: "Congo",
    en: "Congo",
  },
  {
    value: "Congo, The Democratic Republic of The",
    zh: "Congo, The Democratic Republic of The",
    en: "Congo, The Democratic Republic of The",
  },
  {
    value: "Cook Islands",
    zh: "Cook Islands",
    en: "Cook Islands",
  },
  {
    value: "Costa Rica",
    zh: "Costa Rica",
    en: "Costa Rica",
  },
  {
    value: "Cote D'Ivoire",
    zh: "Cote D'Ivoire",
    en: "Cote D'Ivoire",
  },
  {
    value: "Croatia",
    zh: "Croatia",
    en: "Croatia",
  },
  {
    value: "Cuba",
    zh: "Cuba",
    en: "Cuba",
  },
  {
    value: "Curacao",
    zh: "Curacao",
    en: "Curacao",
  },
  {
    value: "Cyprus",
    zh: "Cyprus",
    en: "Cyprus",
  },
  {
    value: "Czechia",
    zh: "Czechia",
    en: "Czechia",
  },
  {
    value: "Denmark",
    zh: "Denmark",
    en: "Denmark",
  },
  {
    value: "Djibouti",
    zh: "Djibouti",
    en: "Djibouti",
  },
  {
    value: "Dominica",
    zh: "Dominica",
    en: "Dominica",
  },
  {
    value: "Dominican Republic",
    zh: "Dominican Republic",
    en: "Dominican Republic",
  },
  {
    value: "Ecuador",
    zh: "Ecuador",
    en: "Ecuador",
  },
  {
    value: "Egypt",
    zh: "Egypt",
    en: "Egypt",
  },
  {
    value: "El Salvador",
    zh: "El Salvador",
    en: "El Salvador",
  },
  {
    value: "Equatorial Guinea",
    zh: "Equatorial Guinea",
    en: "Equatorial Guinea",
  },
  {
    value: "Eritrea",
    zh: "Eritrea",
    en: "Eritrea",
  },
  {
    value: "Estonia",
    zh: "Estonia",
    en: "Estonia",
  },
  {
    value: "Eswatini",
    zh: "Eswatini",
    en: "Eswatini",
  },
  {
    value: "Ethiopia",
    zh: "Ethiopia",
    en: "Ethiopia",
  },
  {
    value: "Falkland Islands (Malvinas)",
    zh: "Falkland Islands (Malvinas)",
    en: "Falkland Islands (Malvinas)",
  },
  {
    value: "Faroe Islands",
    zh: "Faroe Islands",
    en: "Faroe Islands",
  },
  {
    value: "Fiji",
    zh: "Fiji",
    en: "Fiji",
  },
  {
    value: "Finland",
    zh: "Finland",
    en: "Finland",
  },
  {
    value: "France",
    zh: "France",
    en: "France",
  },
  {
    value: "French Guiana",
    zh: "French Guiana",
    en: "French Guiana",
  },
  {
    value: "French Polynesia",
    zh: "French Polynesia",
    en: "French Polynesia",
  },
  {
    value: "French Southern Territories",
    zh: "French Southern Territories",
    en: "French Southern Territories",
  },
  {
    value: "Gabon",
    zh: "Gabon",
    en: "Gabon",
  },
  {
    value: "Gambia",
    zh: "Gambia",
    en: "Gambia",
  },
  {
    value: "Georgia",
    zh: "Georgia",
    en: "Georgia",
  },
  {
    value: "Germany",
    zh: "Germany",
    en: "Germany",
  },
  {
    value: "Ghana",
    zh: "Ghana",
    en: "Ghana",
  },
  {
    value: "Gibraltar",
    zh: "Gibraltar",
    en: "Gibraltar",
  },
  {
    value: "Greece",
    zh: "Greece",
    en: "Greece",
  },
  {
    value: "Greenland",
    zh: "Greenland",
    en: "Greenland",
  },
  {
    value: "Grenada",
    zh: "Grenada",
    en: "Grenada",
  },
  {
    value: "Guadeloupe",
    zh: "Guadeloupe",
    en: "Guadeloupe",
  },
  {
    value: "Guam",
    zh: "Guam",
    en: "Guam",
  },
  {
    value: "Guatemala",
    zh: "Guatemala",
    en: "Guatemala",
  },
  {
    value: "Guernsey",
    zh: "Guernsey",
    en: "Guernsey",
  },
  {
    value: "Guinea",
    zh: "Guinea",
    en: "Guinea",
  },
  {
    value: "Guinea-Bissau",
    zh: "Guinea-Bissau",
    en: "Guinea-Bissau",
  },
  {
    value: "Guyana",
    zh: "Guyana",
    en: "Guyana",
  },
  {
    value: "Haiti",
    zh: "Haiti",
    en: "Haiti",
  },
  {
    value: "Heard Island And Mcdonald Islands",
    zh: "Heard Island And Mcdonald Islands",
    en: "Heard Island And Mcdonald Islands",
  },
  {
    value: "Holy See",
    zh: "Holy See",
    en: "Holy See",
  },
  {
    value: "Honduras",
    zh: "Honduras",
    en: "Honduras",
  },
  {
    value: "Hungary",
    zh: "Hungary",
    en: "Hungary",
  },
  {
    value: "Iceland",
    zh: "Iceland",
    en: "Iceland",
  },
  {
    value: "India",
    zh: "India",
    en: "India",
  },
  {
    value: "Indonesia",
    zh: "Indonesia",
    en: "Indonesia",
  },
  {
    value: "Iran, Islamic Republic of",
    zh: "Iran, Islamic Republic of",
    en: "Iran, Islamic Republic of",
  },
  {
    value: "Iraq",
    zh: "Iraq",
    en: "Iraq",
  },
  {
    value: "Ireland",
    zh: "Ireland",
    en: "Ireland",
  },
  {
    value: "Isle of Man",
    zh: "Isle of Man",
    en: "Isle of Man",
  },
  {
    value: "Israel",
    zh: "Israel",
    en: "Israel",
  },
  {
    value: "Italy",
    zh: "Italy",
    en: "Italy",
  },
  {
    value: "Jamaica",
    zh: "Jamaica",
    en: "Jamaica",
  },
  {
    value: "Japan",
    zh: "Japan",
    en: "Japan",
  },
  {
    value: "Jordan",
    zh: "Jordan",
    en: "Jordan",
  },
  {
    value: "Kazakhstan",
    zh: "Kazakhstan",
    en: "Kazakhstan",
  },
  {
    value: "Kenya",
    zh: "Kenya",
    en: "Kenya",
  },
  {
    value: "Kiribati",
    zh: "Kiribati",
    en: "Kiribati",
  },
  {
    value: "Korea, Democratic People's Republic of",
    zh: "Korea, Democratic People's Republic of",
    en: "Korea, Democratic People's Republic of",
  },
  {
    value: "Korea, Republic of",
    zh: "Korea, Republic of",
    en: "Korea, Republic of",
  },
  {
    value: "Kuwait",
    zh: "Kuwait",
    en: "Kuwait",
  },
  {
    value: "Kyrgyzstan",
    zh: "Kyrgyzstan",
    en: "Kyrgyzstan",
  },
  {
    value: "Lao People's Democratic Republic",
    zh: "Lao People's Democratic Republic",
    en: "Lao People's Democratic Republic",
  },
  {
    value: "Latvia",
    zh: "Latvia",
    en: "Latvia",
  },
  {
    value: "Lebanon",
    zh: "Lebanon",
    en: "Lebanon",
  },
  {
    value: "Lesotho",
    zh: "Lesotho",
    en: "Lesotho",
  },
  {
    value: "Liberia",
    zh: "Liberia",
    en: "Liberia",
  },
  {
    value: "Libya",
    zh: "Libya",
    en: "Libya",
  },
  {
    value: "Liechtenstein",
    zh: "Liechtenstein",
    en: "Liechtenstein",
  },
  {
    value: "Lithuania",
    zh: "Lithuania",
    en: "Lithuania",
  },
  {
    value: "Luxembourg",
    zh: "Luxembourg",
    en: "Luxembourg",
  },
  {
    value: "Macao",
    zh: "Macao",
    en: "Macao",
  },
  {
    value: "Madagascar",
    zh: "Madagascar",
    en: "Madagascar",
  },
  {
    value: "Malawi",
    zh: "Malawi",
    en: "Malawi",
  },
  {
    value: "Maldives",
    zh: "Maldives",
    en: "Maldives",
  },
  {
    value: "Mali",
    zh: "Mali",
    en: "Mali",
  },
  {
    value: "Malta",
    zh: "Malta",
    en: "Malta",
  },
  {
    value: "Marshall Islands",
    zh: "Marshall Islands",
    en: "Marshall Islands",
  },
  {
    value: "Martinique",
    zh: "Martinique",
    en: "Martinique",
  },
  {
    value: "Mauritania",
    zh: "Mauritania",
    en: "Mauritania",
  },
  {
    value: "Mauritius",
    zh: "Mauritius",
    en: "Mauritius",
  },
  {
    value: "Mayotte",
    zh: "Mayotte",
    en: "Mayotte",
  },
  {
    value: "Mexico",
    zh: "Mexico",
    en: "Mexico",
  },
  {
    value: "Micronesia",
    zh: "Micronesia",
    en: "Micronesia",
  },
  {
    value: "Moldova",
    zh: "Moldova",
    en: "Moldova",
  },
  {
    value: "Monaco",
    zh: "Monaco",
    en: "Monaco",
  },
  {
    value: "Mongolia",
    zh: "Mongolia",
    en: "Mongolia",
  },
  {
    value: "Montenegro",
    zh: "Montenegro",
    en: "Montenegro",
  },
  {
    value: "Montserrat",
    zh: "Montserrat",
    en: "Montserrat",
  },
  {
    value: "Morocco",
    zh: "Morocco",
    en: "Morocco",
  },
  {
    value: "Mozambique",
    zh: "Mozambique",
    en: "Mozambique",
  },
  {
    value: "Myanmar",
    zh: "Myanmar",
    en: "Myanmar",
  },
  {
    value: "Namibia",
    zh: "Namibia",
    en: "Namibia",
  },
  {
    value: "Nauru",
    zh: "Nauru",
    en: "Nauru",
  },
  {
    value: "Nepal",
    zh: "Nepal",
    en: "Nepal",
  },
  {
    value: "Netherlands",
    zh: "Netherlands",
    en: "Netherlands",
  },
  {
    value: "New Caledonia",
    zh: "New Caledonia",
    en: "New Caledonia",
  },
  {
    value: "New Zealand",
    zh: "New Zealand",
    en: "New Zealand",
  },
  {
    value: "Nicaragua",
    zh: "Nicaragua",
    en: "Nicaragua",
  },
  {
    value: "Niger",
    zh: "Niger",
    en: "Niger",
  },
  {
    value: "Nigeria",
    zh: "Nigeria",
    en: "Nigeria",
  },
  {
    value: "Niue",
    zh: "Niue",
    en: "Niue",
  },
  {
    value: "Norfolk Island",
    zh: "Norfolk Island",
    en: "Norfolk Island",
  },
  {
    value: "North Macedonia",
    zh: "North Macedonia",
    en: "North Macedonia",
  },
  {
    value: "Northern Mariana Islands",
    zh: "Northern Mariana Islands",
    en: "Northern Mariana Islands",
  },
  {
    value: "Norway",
    zh: "Norway",
    en: "Norway",
  },
  {
    value: "Oman",
    zh: "Oman",
    en: "Oman",
  },
  {
    value: "Pakistan",
    zh: "Pakistan",
    en: "Pakistan",
  },
  {
    value: "Palau",
    zh: "Palau",
    en: "Palau",
  },
  {
    value: "Palestine State",
    zh: "Palestine State",
    en: "Palestine State",
  },
  {
    value: "Panama",
    zh: "Panama",
    en: "Panama",
  },
  {
    value: "Papua New Guinea",
    zh: "Papua New Guinea",
    en: "Papua New Guinea",
  },
  {
    value: "Paraguay",
    zh: "Paraguay",
    en: "Paraguay",
  },
  {
    value: "Peru",
    zh: "Peru",
    en: "Peru",
  },
  {
    value: "Philippines",
    zh: "Philippines",
    en: "Philippines",
  },
  {
    value: "Pitcairn",
    zh: "Pitcairn",
    en: "Pitcairn",
  },
  {
    value: "Poland",
    zh: "Poland",
    en: "Poland",
  },
  {
    value: "Portugal",
    zh: "Portugal",
    en: "Portugal",
  },
  {
    value: "Puerto Rico",
    zh: "Puerto Rico",
    en: "Puerto Rico",
  },
  {
    value: "Qatar",
    zh: "Qatar",
    en: "Qatar",
  },
  {
    value: "Reunion",
    zh: "Reunion",
    en: "Reunion",
  },
  {
    value: "Romania",
    zh: "Romania",
    en: "Romania",
  },
  {
    value: "Russian Federation",
    zh: "Russian Federation",
    en: "Russian Federation",
  },
  {
    value: "Rwanda",
    zh: "Rwanda",
    en: "Rwanda",
  },
  {
    value: "Saint Barthelemy",
    zh: "Saint Barthelemy",
    en: "Saint Barthelemy",
  },
  {
    value: "Saint Helena Ascension and Tristan Da Cunha",
    zh: "Saint Helena Ascension and Tristan Da Cunha",
    en: "Saint Helena Ascension and Tristan Da Cunha",
  },
  {
    value: "Saint Kitts and Nevis",
    zh: "Saint Kitts and Nevis",
    en: "Saint Kitts and Nevis",
  },
  {
    value: "Saint Lucia",
    zh: "Saint Lucia",
    en: "Saint Lucia",
  },
  {
    value: "Saint Marino (French Part)",
    zh: "Saint Marino (French Part)",
    en: "Saint Marino (French Part)",
  },
  {
    value: "Saint Pierre and Miquelon",
    zh: "Saint Pierre and Miquelon",
    en: "Saint Pierre and Miquelon",
  },
  {
    value: "Saint Vincent and the Grenadines",
    zh: "Saint Vincent and the Grenadines",
    en: "Saint Vincent and the Grenadines",
  },
  {
    value: "Samoa",
    zh: "Samoa",
    en: "Samoa",
  },
  {
    value: "San Marino",
    zh: "San Marino",
    en: "San Marino",
  },
  {
    value: "Sao Tome and Principe",
    zh: "Sao Tome and Principe",
    en: "Sao Tome and Principe",
  },
  {
    value: "Saudi Arabia",
    zh: "Saudi Arabia",
    en: "Saudi Arabia",
  },
  {
    value: "Senegal",
    zh: "Senegal",
    en: "Senegal",
  },
  {
    value: "Serbia",
    zh: "Serbia",
    en: "Serbia",
  },
  {
    value: "Seychelles",
    zh: "Seychelles",
    en: "Seychelles",
  },
  {
    value: "Sierra Leone",
    zh: "Sierra Leone",
    en: "Sierra Leone",
  },
  {
    value: "Sint Maarten (Dutch Part)",
    zh: "Sint Maarten (Dutch Part)",
    en: "Sint Maarten (Dutch Part)",
  },
  {
    value: "Slovakia",
    zh: "Slovakia",
    en: "Slovakia",
  },
  {
    value: "Slovenia",
    zh: "Slovenia",
    en: "Slovenia",
  },
  {
    value: "Solomon Islands",
    zh: "Solomon Islands",
    en: "Solomon Islands",
  },
  {
    value: "Somalia",
    zh: "Somalia",
    en: "Somalia",
  },
  {
    value: "South Africa",
    zh: "South Africa",
    en: "South Africa",
  },
  {
    value: "South Korea",
    zh: "South Korea",
    en: "South Korea",
  },
  {
    value: "South Georgia and The Souch Sandwich Islands",
    zh: "South Georgia and The Souch Sandwich Islands",
    en: "South Georgia and The Souch Sandwich Islands",
  },
  {
    value: "South Sudan",
    zh: "South Sudan",
    en: "South Sudan",
  },
  {
    value: "Spain",
    zh: "Spain",
    en: "Spain",
  },
  {
    value: "Sri Lanka",
    zh: "Sri Lanka",
    en: "Sri Lanka",
  },
  {
    value: "Sudan",
    zh: "Sudan",
    en: "Sudan",
  },
  {
    value: "Suriname",
    zh: "Suriname",
    en: "Suriname",
  },
  {
    value: "Svalbard and Jan Mayen",
    zh: "Svalbard and Jan Mayen",
    en: "Svalbard and Jan Mayen",
  },
  {
    value: "Sweden",
    zh: "Sweden",
    en: "Sweden",
  },
  {
    value: "Switzerland",
    zh: "Switzerland",
    en: "Switzerland",
  },
  {
    value: "Syrian Arab Republic",
    zh: "Syrian Arab Republic",
    en: "Syrian Arab Republic",
  },
  {
    value: "Taiwan",
    zh: "Taiwan",
    en: "Taiwan",
  },
  {
    value: "Tajikistan",
    zh: "Tajikistan",
    en: "Tajikistan",
  },
  {
    value: "Tanzania, United Republic of",
    zh: "Tanzania, United Republic of",
    en: "Tanzania, United Republic of",
  },
  {
    value: "Thailand",
    zh: "Thailand",
    en: "Thailand",
  },
  {
    value: "Timor-Leste",
    zh: "Timor-Leste",
    en: "Timor-Leste",
  },
  {
    value: "Togo",
    zh: "Togo",
    en: "Togo",
  },
  {
    value: "Tokelau",
    zh: "Tokelau",
    en: "Tokelau",
  },
  {
    value: "Tonga",
    zh: "Tonga",
    en: "Tonga",
  },
  {
    value: "Trinidad and Tobago",
    zh: "Trinidad and Tobago",
    en: "Trinidad and Tobago",
  },
  {
    value: "Tunisia",
    zh: "Tunisia",
    en: "Tunisia",
  },
  {
    value: "Turkey",
    zh: "Turkey",
    en: "Turkey",
  },
  {
    value: "Turkmenistan",
    zh: "Turkmenistan",
    en: "Turkmenistan",
  },
  {
    value: "Turks and Caicos Islands",
    zh: "Turks and Caicos Islands",
    en: "Turks and Caicos Islands",
  },
  {
    value: "Tuvalu",
    zh: "Tuvalu",
    en: "Tuvalu",
  },
  {
    value: "Uganda",
    zh: "Uganda",
    en: "Uganda",
  },
  {
    value: "Ukraine",
    zh: "Ukraine",
    en: "Ukraine",
  },
  {
    value: "United Arab Emirates",
    zh: "United Arab Emirates",
    en: "United Arab Emirates",
  },
  {
    value: "United Kingdom of Great Britain and Northern Ireland",
    zh: "United Kingdom of Great Britain and Northern Ireland",
    en: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    value: "United States Minor Outlying Islands",
    zh: "United States Minor Outlying Islands",
    en: "United States Minor Outlying Islands",
  },
  {
    value: "United States of America",
    zh: "United States of America",
    en: "United States of America",
  },
  {
    value: "Uruguay",
    zh: "Uruguay",
    en: "Uruguay",
  },
  {
    value: "Uzbekistan",
    zh: "Uzbekistan",
    en: "Uzbekistan",
  },
  {
    value: "Vanuatu",
    zh: "Vanuatu",
    en: "Vanuatu",
  },
  {
    value: "Venezuela Bolivarian Republic of",
    zh: "Venezuela Bolivarian Republic of",
    en: "Venezuela Bolivarian Republic of",
  },
  {
    value: "Vietnam",
    zh: "Vietnam",
    en: "Vietnam",
  },
  {
    value: "Virgin Islands, British",
    zh: "Virgin Islands, British",
    en: "Virgin Islands, British",
  },
  {
    value: "Virgin Islands, U.S.",
    zh: "Virgin Islands, U.S.",
    en: "Virgin Islands, U.S.",
  },
  {
    value: "Wallis and Futuna",
    zh: "Wallis and Futuna",
    en: "Wallis and Futuna",
  },
  {
    value: "Western Sahara",
    zh: "Western Sahara",
    en: "Western Sahara",
  },
  {
    value: "Yemen",
    zh: "Yemen",
    en: "Yemen",
  },
  {
    value: "Zambia",
    zh: "Zambia",
    en: "Zambia",
  },
  {
    value: "Zimbabwe",
    zh: "Zimbabwe",
    en: "Zimbabwe",
  },
];
// 国籍
export const nationalityList = [
  {
    value: "Singaporean",
    zh: "Singaporean 新加坡",
    en: "Singaporean",
  },
  {
    value: "Malaysian",
    zh: "Malaysian 马来西亚",
    en: "Malaysian",
  },
  {
    value: "Chinese",
    zh: "Chinese 中国",
    en: "Chinese",
  },
  {
    value: "Chinese/Hong Kong Sar",
    zh: "Chinese/Hong Kong Sar 中国香港",
    en: "Chinese/Hong Kong Sar",
  },
  {
    value: "Chinese/Macau Sar",
    zh: "Chinese/Macau Sar 中国澳门",
    en: "Chinese/Macau Sar",
  },
  {
    value: "Afghan",
    zh: "Afghan",
    en: "Afghan",
  },
  {
    value: "Albanian",
    zh: "Albanian",
    en: "Albanian",
  },
  {
    value: "Algerian",
    zh: "Algerian",
    en: "Algerian",
  },
  {
    value: "American",
    zh: "American",
    en: "American",
  },
  {
    value: "Andorran",
    zh: "Andorran",
    en: "Andorran",
  },
  {
    value: "Angolan",
    zh: "Angolan",
    en: "Angolan",
  },
  {
    value: "Antiguan",
    zh: "Antiguan",
    en: "Antiguan",
  },
  {
    value: "Argentinian",
    zh: "Argentinian",
    en: "Argentinian",
  },
  {
    value: "Armenian",
    zh: "Armenian",
    en: "Armenian",
  },
  {
    value: "Australian",
    zh: "Australian",
    en: "Australian",
  },
  {
    value: "Austrian",
    zh: "Austrian",
    en: "Austrian",
  },
  {
    value: "Azerbaijani",
    zh: "Azerbaijani",
    en: "Azerbaijani",
  },
  {
    value: "Bahamian",
    zh: "Bahamian",
    en: "Bahamian",
  },
  {
    value: "Bahraini",
    zh: "Bahraini",
    en: "Bahraini",
  },
  {
    value: "Bangladeshi",
    zh: "Bangladeshi",
    en: "Bangladeshi",
  },
  {
    value: "Barbados",
    zh: "Barbados",
    en: "Barbados",
  },
  {
    value: "Belarussian",
    zh: "Belarussian",
    en: "Belarussian",
  },
  {
    value: "Belgian",
    zh: "Belgian",
    en: "Belgian",
  },
  {
    value: "Belizeah",
    zh: "Belizeah",
    en: "Belizeah",
  },
  {
    value: "Beninese",
    zh: "Beninese",
    en: "Beninese",
  },
  {
    value: "Bhutanese",
    zh: "Bhutanese",
    en: "Bhutanese",
  },
  {
    value: "Bolivian",
    zh: "Bolivian",
    en: "Bolivian",
  },
  {
    value: "Bosnia",
    zh: "Bosnia",
    en: "Bosnia",
  },
  {
    value: "Batswana",
    zh: "Batswana",
    en: "Batswana",
  },
  {
    value: "Brazilian",
    zh: "Brazilian",
    en: "Brazilian",
  },
  {
    value: "British",
    zh: "British",
    en: "British",
  },
  {
    value: "British National Overseas",
    zh: "British National Overseas",
    en: "British National Overseas",
  },
  {
    value: "British Overseas Citizen",
    zh: "British Overseas Citizen",
    en: "British Overseas Citizen",
  },
  {
    value: "British Overseas Territories Citizen",
    zh: "British Overseas Territories Citizen",
    en: "British Overseas Territories Citizen",
  },
  {
    value: "British Protected Person",
    zh: "British Protected Person",
    en: "British Protected Person",
  },
  {
    value: "British Subject",
    zh: "British Subject",
    en: "British Subject",
  },
  {
    value: "Bruneian",
    zh: "Bruneian",
    en: "Bruneian",
  },
  {
    value: "Bulgarian",
    zh: "Bulgarian",
    en: "Bulgarian",
  },
  {
    value: "Burkinabe",
    zh: "Burkinabe",
    en: "Burkinabe",
  },
  {
    value: "Burundian",
    zh: "Burundian",
    en: "Burundian",
  },
  {
    value: "Cambodian",
    zh: "Cambodian",
    en: "Cambodian",
  },
  {
    value: "Cameroonian",
    zh: "Cameroonian",
    en: "Cameroonian",
  },
  {
    value: "Canadian",
    zh: "Canadian",
    en: "Canadian",
  },
  {
    value: "Cape Verdean",
    zh: "Cape Verdean",
    en: "Cape Verdean",
  },
  {
    value: "Cayman Islands",
    zh: "Cayman Islands",
    en: "Cayman Islands",
  },
  {
    value: "Central African Republic",
    zh: "Central African Republic",
    en: "Central African Republic",
  },
  {
    value: "Chadian",
    zh: "Chadian",
    en: "Chadian",
  },
  {
    value: "Chilean",
    zh: "Chilean",
    en: "Chilean",
  },
  {
    value: "Chinese/ Taiwanese",
    zh: "Chinese/ Taiwanese",
    en: "Chinese/ Taiwanese",
  },
  {
    value: "Colombia",
    zh: "Colombia",
    en: "Colombia",
  },
  {
    value: "Comoran",
    zh: "Comoran",
    en: "Comoran",
  },
  {
    value: "Congolese",
    zh: "Congolese",
    en: "Congolese",
  },
  {
    value: "Costa Rican",
    zh: "Costa Rican",
    en: "Costa Rican",
  },
  {
    value: "Croatian",
    zh: "Croatian",
    en: "Croatian",
  },
  {
    value: "Cuban",
    zh: "Cuban",
    en: "Cuban",
  },
  {
    value: "Cyprot",
    zh: "Cyprot",
    en: "Cyprot",
  },
  {
    value: "Czech",
    zh: "Czech",
    en: "Czech",
  },
  {
    value: "D.P.R.Korean",
    zh: "D.P.R.Korean",
    en: "D.P.R.Korean",
  },
  {
    value: "Danish",
    zh: "Danish",
    en: "Danish",
  },
  {
    value: "Democratic Republic of the Congo",
    zh: "Democratic Republic of the Congo",
    en: "Democratic Republic of the Congo",
  },
  {
    value: "Djiboutian",
    zh: "Djiboutian",
    en: "Djiboutian",
  },
  {
    value: "Dominican",
    zh: "Dominican",
    en: "Dominican",
  },
  {
    value: "Dominican (Republic)",
    zh: "Dominican (Republic)",
    en: "Dominican (Republic)",
  },
  {
    value: "East Timorese",
    zh: "East Timorese",
    en: "East Timorese",
  },
  {
    value: "Ecuadorian",
    zh: "Ecuadorian",
    en: "Ecuadorian",
  },
  {
    value: "Egyptian",
    zh: "Egyptian",
    en: "Egyptian",
  },
  {
    value: "Equatorial Guinea",
    zh: "Equatorial Guinea",
    en: "Equatorial Guinea",
  },
  {
    value: "Eritrean",
    zh: "Eritrean",
    en: "Eritrean",
  },
  {
    value: "Estonian",
    zh: "Estonian",
    en: "Estonian",
  },
  {
    value: "Ethiopian",
    zh: "Ethiopian",
    en: "Ethiopian",
  },
  {
    value: "Fijian",
    zh: "Fijian",
    en: "Fijian",
  },
  {
    value: "Filipino",
    zh: "Filipino",
    en: "Filipino",
  },
  {
    value: "Finnish",
    zh: "Finnish",
    en: "Finnish",
  },
  {
    value: "French",
    zh: "French",
    en: "French",
  },
  {
    value: "Gabon",
    zh: "Gabon",
    en: "Gabon",
  },
  {
    value: "Gambian",
    zh: "Gambian",
    en: "Gambian",
  },
  {
    value: "Georgian",
    zh: "Georgian",
    en: "Georgian",
  },
  {
    value: "German",
    zh: "German",
    en: "German",
  },
  {
    value: "Ghanaian",
    zh: "Ghanaian",
    en: "Ghanaian",
  },
  {
    value: "Greek",
    zh: "Greek",
    en: "Greek",
  },
  {
    value: "Grenadian",
    zh: "Grenadian",
    en: "Grenadian",
  },
  {
    value: "Guatemalan",
    zh: "Guatemalan",
    en: "Guatemalan",
  },
  {
    value: "Guinean",
    zh: "Guinean",
    en: "Guinean",
  },
  {
    value: "Guinean (Bissau)",
    zh: "Guinean (Bissau)",
    en: "Guinean (Bissau)",
  },
  {
    value: "Guyanese",
    zh: "Guyanese",
    en: "Guyanese",
  },
  {
    value: "Haitian",
    zh: "Haitian",
    en: "Haitian",
  },
  {
    value: "Honduran",
    zh: "Honduran",
    en: "Honduran",
  },
  {
    value: "Hungarian",
    zh: "Hungarian",
    en: "Hungarian",
  },
  {
    value: "Icelander",
    zh: "Icelander",
    en: "Icelander",
  },
  {
    value: "Indian",
    zh: "Indian",
    en: "Indian",
  },
  {
    value: "Indonesian",
    zh: "Indonesian",
    en: "Indonesian",
  },
  {
    value: "Iranian",
    zh: "Iranian",
    en: "Iranian",
  },
  {
    value: "Iraqi",
    zh: "Iraqi",
    en: "Iraqi",
  },
  {
    value: "Irish",
    zh: "Irish",
    en: "Irish",
  },
  {
    value: "Israeli",
    zh: "Israeli",
    en: "Israeli",
  },
  {
    value: "Italian",
    zh: "Italian",
    en: "Italian",
  },
  {
    value: "Ivory Coast",
    zh: "Ivory Coast",
    en: "Ivory Coast",
  },
  {
    value: "Jamaican",
    zh: "Jamaican",
    en: "Jamaican",
  },
  {
    value: "Japanese",
    zh: "Japanese",
    en: "Japanese",
  },
  {
    value: "Jordanian",
    zh: "Jordanian",
    en: "Jordanian",
  },
  {
    value: "Kazakhstani",
    zh: "Kazakhstani",
    en: "Kazakhstani",
  },
  {
    value: "Kenyan",
    zh: "Kenyan",
    en: "Kenyan",
  },
  {
    value: "Kiribati",
    zh: "Kiribati",
    en: "Kiribati",
  },
  {
    value: "Korean, South",
    zh: "Korean, South",
    en: "Korean, South",
  },
  {
    value: "Kosovar",
    zh: "Kosovar",
    en: "Kosovar",
  },
  {
    value: "Kuwaiti",
    zh: "Kuwaiti",
    en: "Kuwaiti",
  },
  {
    value: "Kyrgyzstan",
    zh: "Kyrgyzstan",
    en: "Kyrgyzstan",
  },
  {
    value: "Laotian",
    zh: "Laotian",
    en: "Laotian",
  },
  {
    value: "Latvian",
    zh: "Latvian",
    en: "Latvian",
  },
  {
    value: "Lebanese",
    zh: "Lebanese",
    en: "Lebanese",
  },
  {
    value: "Lesotho",
    zh: "Lesotho",
    en: "Lesotho",
  },
  {
    value: "Liberian",
    zh: "Liberian",
    en: "Liberian",
  },
  {
    value: "Libyan",
    zh: "Libyan",
    en: "Libyan",
  },
  {
    value: "Liechtensteiner",
    zh: "Liechtensteiner",
    en: "Liechtensteiner",
  },
  {
    value: "Lithuanian",
    zh: "Lithuanian",
    en: "Lithuanian",
  },
  {
    value: "Luxembourger",
    zh: "Luxembourger",
    en: "Luxembourger",
  },
  {
    value: "Macedonian",
    zh: "Macedonian",
    en: "Macedonian",
  },
  {
    value: "Malagasy",
    zh: "Malagasy",
    en: "Malagasy",
  },
  {
    value: "Malawian",
    zh: "Malawian",
    en: "Malawian",
  },
  {
    value: "Maldivian",
    zh: "Maldivian",
    en: "Maldivian",
  },
  {
    value: "Malian",
    zh: "Malian",
    en: "Malian",
  },
  {
    value: "Maltese",
    zh: "Maltese",
    en: "Maltese",
  },
  {
    value: "Marshallese",
    zh: "Marshallese",
    en: "Marshallese",
  },
  {
    value: "Mauritanean",
    zh: "Mauritanean",
    en: "Mauritanean",
  },
  {
    value: "Mauritian",
    zh: "Mauritian",
    en: "Mauritian",
  },
  {
    value: "Mexican",
    zh: "Mexican",
    en: "Mexican",
  },
  {
    value: "Micronesian",
    zh: "Micronesian",
    en: "Micronesian",
  },
  {
    value: "Moldavian",
    zh: "Moldavian",
    en: "Moldavian",
  },
  {
    value: "Monacan",
    zh: "Monacan",
    en: "Monacan",
  },
  {
    value: "Mongolian",
    zh: "Mongolian",
    en: "Mongolian",
  },
  {
    value: "Montenegrin",
    zh: "Montenegrin",
    en: "Montenegrin",
  },
  {
    value: "Moroccan",
    zh: "Moroccan",
    en: "Moroccan",
  },
  {
    value: "Mozambican",
    zh: "Mozambican",
    en: "Mozambican",
  },
  {
    value: "Myanmar",
    zh: "Myanmar",
    en: "Myanmar",
  },
  {
    value: "Namibian",
    zh: "Namibian",
    en: "Namibian",
  },
  {
    value: "Nauruan",
    zh: "Nauruan",
    en: "Nauruan",
  },
  {
    value: "Nepalese",
    zh: "Nepalese",
    en: "Nepalese",
  },
  {
    value: "Netherlands",
    zh: "Netherlands",
    en: "Netherlands",
  },
  {
    value: "New Zealander",
    zh: "New Zealander",
    en: "New Zealander",
  },
  {
    value: "Ni-Vanuatu",
    zh: "Ni-Vanuatu",
    en: "Ni-Vanuatu",
  },
  {
    value: "Nicaraguan",
    zh: "Nicaraguan",
    en: "Nicaraguan",
  },
  {
    value: "Niger",
    zh: "Niger",
    en: "Niger",
  },
  {
    value: "Nigerian",
    zh: "Nigerian",
    en: "Nigerian",
  },
  {
    value: "Norwegian",
    zh: "Norwegian",
    en: "Norwegian",
  },
  {
    value: "Omani",
    zh: "Omani",
    en: "Omani",
  },
  {
    value: "Pakistani",
    zh: "Pakistani",
    en: "Pakistani",
  },
  {
    value: "Palauan",
    zh: "Palauan",
    en: "Palauan",
  },
  {
    value: "Palestinian",
    zh: "Palestinian",
    en: "Palestinian",
  },
  {
    value: "Panamanian",
    zh: "Panamanian",
    en: "Panamanian",
  },
  {
    value: "Papua New Guinean",
    zh: "Papua New Guinean",
    en: "Papua New Guinean",
  },
  {
    value: "Paraguayan",
    zh: "Paraguayan",
    en: "Paraguayan",
  },
  {
    value: "Peruvian",
    zh: "Peruvian",
    en: "Peruvian",
  },
  {
    value: "Philippine",
    zh: "Philippine",
    en: "Philippine",
  },
  {
    value: "Polish",
    zh: "Polish",
    en: "Polish",
  },
  {
    value: "Portuguese",
    zh: "Portuguese",
    en: "Portuguese",
  },
  {
    value: "Qatari",
    zh: "Qatari",
    en: "Qatari",
  },
  {
    value: "Romanian",
    zh: "Romanian",
    en: "Romanian",
  },
  {
    value: "Russian",
    zh: "Russian",
    en: "Russian",
  },
  {
    value: "Rwandan",
    zh: "Rwandan",
    en: "Rwandan",
  },
  {
    value: "Salvadorian",
    zh: "Salvadorian",
    en: "Salvadorian",
  },
  {
    value: "Sammarinese",
    zh: "Sammarinese",
    en: "Sammarinese",
  },
  {
    value: "Samoan",
    zh: "Samoan",
    en: "Samoan",
  },
  {
    value: "Sao Tomean",
    zh: "Sao Tomean",
    en: "Sao Tomean",
  },
  {
    value: "Saudi Arabian",
    zh: "Saudi Arabian",
    en: "Saudi Arabian",
  },
  {
    value: "Senegalese",
    zh: "Senegalese",
    en: "Senegalese",
  },
  {
    value: "Serbian",
    zh: "Serbian",
    en: "Serbian",
  },
  {
    value: "Seychellois",
    zh: "Seychellois",
    en: "Seychellois",
  },
  {
    value: "Sierra Leone",
    zh: "Sierra Leone",
    en: "Sierra Leone",
  },
  {
    value: "Slovak",
    zh: "Slovak",
    en: "Slovak",
  },
  {
    value: "Slovenian",
    zh: "Slovenian",
    en: "Slovenian",
  },
  {
    value: "Solomon Islander",
    zh: "Solomon Islander",
    en: "Solomon Islander",
  },
  {
    value: "Somali",
    zh: "Somali",
    en: "Somali",
  },
  {
    value: "South African",
    zh: "South African",
    en: "South African",
  },
  {
    value: "Spanish",
    zh: "Spanish",
    en: "Spanish",
  },
  {
    value: "Sri Lankan",
    zh: "Sri Lankan",
    en: "Sri Lankan",
  },
  {
    value: "ST. Lucia",
    zh: "ST. Lucia",
    en: "ST. Lucia",
  },
  {
    value: "ST. Vincentian",
    zh: "ST. Vincentian",
    en: "ST. Vincentian",
  },
  {
    value: "Stateless",
    zh: "Stateless",
    en: "Stateless",
  },
  {
    value: "Sudanese",
    zh: "Sudanese",
    en: "Sudanese",
  },
  {
    value: "Surinamer",
    zh: "Surinamer",
    en: "Surinamer",
  },
  {
    value: "Swazi",
    zh: "Swazi",
    en: "Swazi",
  },
  {
    value: "Swedish",
    zh: "Swedish",
    en: "Swedish",
  },
  {
    value: "Swiss",
    zh: "Swiss",
    en: "Swiss",
  },
  {
    value: "Syrian",
    zh: "Syrian",
    en: "Syrian",
  },
  {
    value: "Tajikistani",
    zh: "Tajikistani",
    en: "Tajikistani",
  },
  {
    value: "Tanzanian",
    zh: "Tanzanian",
    en: "Tanzanian",
  },
  {
    value: "Thai",
    zh: "Thai",
    en: "Thai",
  },
  {
    value: "Togolese",
    zh: "Togolese",
    en: "Togolese",
  },
  {
    value: "Tongan",
    zh: "Tongan",
    en: "Tongan",
  },
  {
    value: "Trinidadian & Tobagonian",
    zh: "Trinidadian & Tobagonian",
    en: "Trinidadian & Tobagonian",
  },
  {
    value: "Tunisian",
    zh: "Tunisian",
    en: "Tunisian",
  },
  {
    value: "Turk",
    zh: "Turk",
    en: "Turk",
  },
  {
    value: "Turkmen",
    zh: "Turkmen",
    en: "Turkmen",
  },
  {
    value: "Tuvalu",
    zh: "Tuvalu",
    en: "Tuvalu",
  },
  {
    value: "Ugandan",
    zh: "Ugandan",
    en: "Ugandan",
  },
  {
    value: "Ukrainian",
    zh: "Ukrainian",
    en: "Ukrainian",
  },
  {
    value: "United Arab Emirates",
    zh: "United Arab Emirates",
    en: "United Arab Emirates",
  },
  {
    value: "Uruguayan",
    zh: "Uruguayan",
    en: "Uruguayan",
  },
  {
    value: "Uzbekistan",
    zh: "Uzbekistan",
    en: "Uzbekistan",
  },
  {
    value: "Vatican City State (Holy See)",
    zh: "Vatican City State (Holy See)",
    en: "Vatican City State (Holy See)",
  },
  {
    value: "Venezuelan",
    zh: "Venezuelan",
    en: "Venezuelan",
  },
  {
    value: "Vietnamese",
    zh: "Vietnamese",
    en: "Vietnamese",
  },
  {
    value: "Yemeni",
    zh: "Yemeni",
    en: "Yemeni",
  },
  {
    value: "Zambian",
    zh: "Zambian",
    en: "Zambian",
  },
  {
    value: "Zimbabwean",
    zh: "Zimbabwean",
    en: "Zimbabwean",
  },
];
// 国家对应的手机区号
export const prefixList = [
  {
    value: "65",
    zh: "+65 新加坡",
    en: "+65 Singapore",
  },
  {
    value: "60",
    zh: "+60 马来西亚",
    en: "+60 Malaysia",
  },
  {
    value: "86",
    zh: "+86 中国",
    en: "+86 China",
  },
  {
    value: "852",
    zh: "+852 中国香港",
    en: "+852 Chinese/Hong Kong Sar",
  },
  {
    value: "853",
    zh: "+853 中国澳门",
    en: "+853 Chinese/Macau Sar",
  },
  {
    value: "886",
    zh: "+886 中国台湾",
    en: "+886 Chinese/Taiwan",
  },
  {
    value: "93",
    zh: "+93 阿富汗",
    en: "+93 Afghanistan",
  },
  {
    value: "355",
    zh: "+355 阿尔巴尼亚",
    en: "+355 Albania",
  },
  {
    value: "213",
    zh: "+213 阿尔格拉",
    en: "+213 Algera",
  },
  {
    value: "376",
    zh: "+376 安道尔",
    en: "+376 Andorra",
  },
  {
    value: "244",
    zh: "+244 安哥拉",
    en: "+244 Angola",
  },
  {
    value: "1264",
    zh: "+1264 安圭拉",
    en: "+1264 Anguilla",
  },
  {
    value: "247",
    zh: "+247 阿森松岛",
    en: "+247 Ascension",
  },
  {
    value: "1268",
    zh: "+1268 安提瓜和巴布达",
    en: "+1268 Antigua and Barbuda",
  },
  {
    value: "54",
    zh: "+54 阿根廷",
    en: "+54 Argentina",
  },
  {
    value: "374",
    zh: "+374 亚美尼亚",
    en: "+374 Armenia",
  },
  {
    value: "297",
    zh: "+297 阿鲁巴",
    en: "+297 Aruba",
  },
  {
    value: "61",
    zh: "+61 澳大利亚",
    en: "+61 Australia",
  },
  {
    value: "43",
    zh: "+43 奥地利",
    en: "+43 Austria",
  },
  {
    value: "994",
    zh: "+994 阿塞拜疆",
    en: "+994 Azerbaijan",
  },
  {
    value: "1242",
    zh: "+1242 巴哈马",
    en: "+1242 Bahamas",
  },
  {
    value: "973",
    zh: "+973 巴林",
    en: "+973 Bahrain",
  },
  {
    value: "880",
    zh: "+880 孟加拉国",
    en: "+880 Bangladesh",
  },
  {
    value: "1246",
    zh: "+1246 巴巴多斯",
    en: "+1246 Barbados",
  },
  {
    value: "375",
    zh: "+375 白俄罗斯",
    en: "+375 Belarus",
  },
  {
    value: "32",
    zh: "+32 比利时",
    en: "+32 Belgium",
  },
  {
    value: "501",
    zh: "+501 伯利兹",
    en: "+501 Belize",
  },
  {
    value: "229",
    zh: "+229 贝宁",
    en: "+229 Benin",
  },
  {
    value: "1441",
    zh: "+1441 百慕大",
    en: "+1441 Bermuda",
  },
  {
    value: "975",
    zh: "+975 不丹",
    en: "+975 Bhutan",
  },
  {
    value: "591",
    zh: "+591 玻利维亚",
    en: "+591 Bolivia",
  },
  {
    value: "387",
    zh: "+387 波斯尼亚和黑塞哥维那",
    en: "+387 Bosnia and Herzegovina",
  },
  {
    value: "267",
    zh: "+267 博茨瓦纳",
    en: "+267 Botwana",
  },
  {
    value: "55",
    zh: "+55 巴西",
    en: "+55 Brazill",
  },
  {
    value: "673",
    zh: "+673 文莱",
    en: "+673 Brunei",
  },
  {
    value: "359",
    zh: "+359 保加利亚",
    en: "+359 Bulgaria",
  },
  {
    value: "226",
    zh: "+226 布基纳法索",
    en: "+226 Burkina Faso",
  },
  {
    value: "257",
    zh: "+257 布隆迪",
    en: "+257 Burundi",
  },
  {
    value: "855",
    zh: "+855 柬埔寨",
    en: "+855 Cambodia",
  },
  {
    value: "237",
    zh: "+237 喀麦隆",
    en: "+237 Cameroon",
  },
  {
    value: "1",
    zh: "+1 加拿大",
    en: "+1 Canada",
  },
  {
    value: "238",
    zh: "+238 佛得角",
    en: "+238 Cape Verde",
  },
  {
    value: "1345",
    zh: "+1345 开曼群岛",
    en: "+1345 Cayman Islands",
  },
  {
    value: "236",
    zh: "+236 中非共和国",
    en: "+236 Central African Republic",
  },
  {
    value: "235",
    zh: "+235 乍得",
    en: "+235 Chad",
  },
  {
    value: "56",
    zh: "+56 智利",
    en: "+56 Chile",
  },
  {
    value: "57",
    zh: "+57 哥伦比亚",
    en: "+57 Colombia",
  },
  {
    value: "269",
    zh: "+269 科摩罗",
    en: "+269 Comoros",
  },
  {
    value: "242",
    zh: "+242 刚果共和国",
    en: "+242 Republic of the Congo",
  },
  {
    value: "243",
    zh: "+243 刚果民主共和国",
    en: "+243 Democratic Republic of the Congo",
  },
  {
    value: "682",
    zh: "+682 库克群岛",
    en: "+682 Cook Islands",
  },
  {
    value: "506",
    zh: "+506 哥斯达黎加",
    en: "+506 Costa Rica",
  },
  {
    value: "225",
    zh: "+225 科特迪沃",
    en: "+225 Cote divoire",
  },
  {
    value: "385",
    zh: "+385 克罗地亚",
    en: "+385 Croatia",
  },
  {
    value: "53",
    zh: "+53 古巴",
    en: "+53 Cuba",
  },
  {
    value: "357",
    zh: "+357 塞浦路斯",
    en: "+357 Cyprus",
  },
  {
    value: "420",
    zh: "+420 捷克共和国",
    en: "+420 Czech Republic",
  },
  {
    value: "45",
    zh: "+45 丹麦",
    en: "+45 Denmark",
  },
  {
    value: "253",
    zh: "+253 吉布提",
    en: "+253 Djibouti",
  },
  {
    value: "1767",
    zh: "+1767 多米尼加",
    en: "+1767 Dominica",
  },
  {
    value: "1809",
    zh: "+1809 多米尼加共和国",
    en: "+1809 Dominican Republic",
  },
  {
    value: "593",
    zh: "+593 厄瓜多尔",
    en: "+593 Ecuador",
  },
  {
    value: "20",
    zh: "+20 埃及",
    en: "+20 Egypt",
  },
  {
    value: "503",
    zh: "+503 艾萨尔瓦多",
    en: "+503 EISalvador",
  },
  {
    value: "372",
    zh: "+372 爱沙尼亚",
    en: "+372 Estonia",
  },
  {
    value: "251",
    zh: "+251 埃塞俄比亚",
    en: "+251 Ethiopia",
  },
  {
    value: "298",
    zh: "+298 法罗群岛",
    en: "+298 Faroe Islands",
  },
  {
    value: "679",
    zh: "+679 斐济",
    en: "+679 Fiji",
  },
  {
    value: "358",
    zh: "+358 芬兰",
    en: "+358 Finland",
  },
  {
    value: "33",
    zh: "+33 法国",
    en: "+33 France",
  },
  {
    value: "594",
    zh: "+594 法属圭亚那",
    en: "+594 French Guiana",
  },
  {
    value: "689",
    zh: "+689 法属波利尼西亚",
    en: "+689 French Polynesia",
  },
  {
    value: "241",
    zh: "+241 加蓬",
    en: "+241 Gabon",
  },
  {
    value: "220",
    zh: "+220 冈比亚",
    en: "+220 Gambia",
  },
  {
    value: "995",
    zh: "+995 格鲁吉亚",
    en: "+995 Georgia",
  },
  {
    value: "94",
    zh: "+94 德国",
    en: "+94 Germany",
  },
  {
    value: "233",
    zh: "+233 加纳",
    en: "+233 Ghana",
  },
  {
    value: "350",
    zh: "+350 直布罗陀",
    en: "+350 Gibraltar",
  },
  {
    value: "30",
    zh: "+30 希腊",
    en: "+30 Greece",
  },
  {
    value: "299",
    zh: "+299 格陵兰",
    en: "+299 Greenland",
  },
  {
    value: "1473",
    zh: "+1473 格林纳达",
    en: "+1473 Grenada",
  },
  {
    value: "590",
    zh: "+590 瓜德罗普",
    en: "+590 Guadeloupe",
  },
  {
    value: "1671",
    zh: "+1671 关岛",
    en: "+1671 Guam",
  },
  {
    value: "502",
    zh: "+502 危地马拉",
    en: "+502 Guatemala",
  },
  {
    value: "240",
    zh: "+240 赤道几内亚",
    en: "+240 Equatorial Guinea",
  },
  {
    value: "245",
    zh: "+245 几内亚比绍",
    en: "+245 Guinea-Bissau",
  },
  {
    value: "44",
    zh: "+44 根西",
    en: "+44 Guernsey",
  },
  {
    value: "224",
    zh: "+224 几内亚",
    en: "+224 Guinea",
  },
  {
    value: "592",
    zh: "+592 圭亚那",
    en: "+592 Guyana",
  },
  {
    value: "509",
    zh: "+509 海地",
    en: "+509 Haiti",
  },
  {
    value: "504",
    zh: "+504 洪都拉斯",
    en: "+504 Honduras",
  },
  {
    value: "95",
    zh: "+95 缅甸",
    en: "+95 Myanmar",
  },
  {
    value: "36",
    zh: "+36 匈牙利",
    en: "+36 Hungary",
  },
  {
    value: "354",
    zh: "+354 冰岛",
    en: "+354 Iceland",
  },
  {
    value: "91",
    zh: "+91 印度",
    en: "+91 Indea",
  },
  {
    value: "62",
    zh: "+62 印度尼西亚",
    en: "+62 Indonesia",
  },
  {
    value: "98",
    zh: "+98 伊朗",
    en: "+98 Iran",
  },
  {
    value: "964",
    zh: "+964 伊拉克",
    en: "+964 Iraq",
  },
  {
    value: "353",
    zh: "+353 爱尔兰",
    en: "+353 Ireland",
  },
  {
    value: "44",
    zh: "+44 马恩岛",
    en: "+44 Isle of Man",
  },
  {
    value: "972",
    zh: "+972 以色列",
    en: "+972 Israel",
  },
  {
    value: "93",
    zh: "+93 意大利",
    en: "+93 Italy",
  },
  {
    value: "1876",
    zh: "+1876 牙买加",
    en: "+1876 Jamaica",
  },
  {
    value: "81",
    zh: "+81 日本",
    en: "+81 Japan",
  },
  {
    value: "44",
    zh: "+44 泽西岛",
    en: "+44 Jersey",
  },
  {
    value: "962",
    zh: "+962 约旦",
    en: "+962 Jordan",
  },
  {
    value: "7",
    zh: "+7 哈萨克斯坦",
    en: "+7 Kazeakhstan",
  },
  {
    value: "254",
    zh: "+254 肯尼亚",
    en: "+254 Kenya",
  },
  {
    value: "383",
    zh: "+383 科索沃",
    en: "+383 Kosovo",
  },
  {
    value: "965",
    zh: "+965 科威特",
    en: "+965 Kuwait",
  },
  {
    value: "996",
    zh: "+996 吉尔吉斯斯坦",
    en: "+996 Kyrgyzstan",
  },
  {
    value: "856",
    zh: "+856 老挝",
    en: "+856 Laos",
  },
  {
    value: "371",
    zh: "+371 拉脱维亚",
    en: "+371 Latvia",
  },
  {
    value: "961",
    zh: "+961 黎巴嫩",
    en: "+961 Lebanon",
  },
  {
    value: "266",
    zh: "+266 莱索托",
    en: "+266 Lesotho",
  },
  {
    value: "231",
    zh: "+231 利比里亚",
    en: "+231 Liberia",
  },
  {
    value: "218",
    zh: "+218 利比亚",
    en: "+218 Libya",
  },
  {
    value: "423",
    zh: "+423 列支敦士登",
    en: "+423 Liechtenstein",
  },
  {
    value: "370",
    zh: "+370 立陶宛",
    en: "+370 Lithuania",
  },
  {
    value: "352",
    zh: "+352 卢森堡",
    en: "+352 Luxembourg",
  },
  {
    value: "389",
    zh: "+389 马其顿",
    en: "+389 Macedonia",
  },
  {
    value: "261",
    zh: "+261 马达加斯加",
    en: "+261 Madagascar",
  },
  {
    value: "265",
    zh: "+265 马拉维",
    en: "+265 Malawi",
  },
  {
    value: "960",
    zh: "+960 马尔代夫",
    en: "+960 Maldives",
  },
  {
    value: "223",
    zh: "+223 马里",
    en: "+223 Mali",
  },
  {
    value: "356",
    zh: "+356 马耳他",
    en: "+356 Malta",
  },
  {
    value: "596",
    zh: "+596 马提尼克",
    en: "+596 Martinique",
  },
  {
    value: "222",
    zh: "+222 毛里塔尼亚",
    en: "+222 Mauritania",
  },
  {
    value: "230",
    zh: "+230 毛里求斯",
    en: "+230 Mauritius",
  },
  {
    value: "262",
    zh: "+262 马约特",
    en: "+262 Mayotte",
  },
  {
    value: "52",
    zh: "+52 墨西哥",
    en: "+52 Mexico",
  },
  {
    value: "373",
    zh: "+373 摩尔多瓦",
    en: "+373 Moldova",
  },
  {
    value: "377",
    zh: "+377 摩纳哥",
    en: "+377 Monaco",
  },
  {
    value: "976",
    zh: "+976 蒙古",
    en: "+976 Mongolia",
  },
  {
    value: "382",
    zh: "+382 黑山",
    en: "+382 Montenegro",
  },
  {
    value: "1664",
    zh: "+1664 蒙特塞拉特",
    en: "+1664 Montserrat",
  },
  {
    value: "212",
    zh: "+212 摩洛哥",
    en: "+212 Morocco",
  },
  {
    value: "258",
    zh: "+258 莫桑比克",
    en: "+258 Mozambique",
  },
  {
    value: "264",
    zh: "+264 纳米比亚",
    en: "+264 Namibia",
  },
  {
    value: "977",
    zh: "+977 尼泊尔",
    en: "+977 Nepal",
  },
  {
    value: "31",
    zh: "+31 荷兰",
    en: "+31 Netherlands",
  },
  {
    value: "599",
    zh: "+599 荷属安的列斯",
    en: "+599 Netherlands Antillse",
  },
  {
    value: "687",
    zh: "+687 新喀里多尼亚",
    en: "+687 New Caledonia",
  },
  {
    value: "64",
    zh: "+64 新西兰",
    en: "+64 NewZealand",
  },
  {
    value: "505",
    zh: "+505 尼加拉瓜",
    en: "+505 Nicaragua",
  },
  {
    value: "227",
    zh: "+227 尼日尔",
    en: "+227 Niger",
  },
  {
    value: "234",
    zh: "+234 尼日利亚",
    en: "+234 Nigeria",
  },
  {
    value: "47",
    zh: "+47 挪威",
    en: "+47 Norway",
  },
  {
    value: "968",
    zh: "+968 阿曼",
    en: "+968 Oman",
  },
  {
    value: "92",
    zh: "+92 巴基斯坦",
    en: "+92 Pakistan",
  },
  {
    value: "970",
    zh: "+970 巴勒斯坦",
    en: "+970 Palestinian",
  },
  {
    value: "507",
    zh: "+507 巴拿马",
    en: "+507 Panama",
  },
  {
    value: "675",
    zh: "+675 巴布亚新几内亚",
    en: "+675 Papua New Guinea",
  },
  {
    value: "595",
    zh: "+595 巴拉圭",
    en: "+595 Paraguay",
  },
  {
    value: "51",
    zh: "+51 秘鲁",
    en: "+51 Peru",
  },
  {
    value: "63",
    zh: "+63 菲律宾",
    en: "+63 Philippines",
  },
  {
    value: "48",
    zh: "+48 波兰",
    en: "+48 Poland",
  },
  {
    value: "351",
    zh: "+351 葡萄牙",
    en: "+351 Portugal",
  },
  {
    value: "1",
    zh: "+1 波多黎各",
    en: "+1 PuertoRico",
  },
  {
    value: "974",
    zh: "+974 库塔",
    en: "+974 Qotar",
  },
  {
    value: "262",
    zh: "+262 留尼汪",
    en: "+262 Reunion",
  },
  {
    value: "40",
    zh: "+40 罗马尼亚",
    en: "+40 Romania",
  },
  {
    value: "7",
    zh: "+7 俄罗斯",
    en: "+7 Russia",
  },
  {
    value: "250",
    zh: "+250 卢旺达",
    en: "+250 Rwanda",
  },
  {
    value: "684",
    zh: "+684 萨摩亚东部",
    en: "+684 Samoa Eastern",
  },
  {
    value: "685",
    zh: "+685 萨摩亚西部",
    en: "+685 Samoa Western",
  },
  {
    value: "378",
    zh: "+378 圣马力诺",
    en: "+378 San Marino",
  },
  {
    value: "239",
    zh: "+239 圣多美和普林西比",
    en: "+239 Sao Tome and Principe",
  },
  {
    value: "966",
    zh: "+966 沙特阿拉伯",
    en: "+966 Saudi Arabia",
  },
  {
    value: "221",
    zh: "+221 塞内加尔",
    en: "+221 Senegal",
  },
  {
    value: "381",
    zh: "+381 塞尔维亚",
    en: "+381 Serbia",
  },
  {
    value: "248",
    zh: "+248 塞舌尔",
    en: "+248 Seychelles",
  },
  {
    value: "232",
    zh: "+232 塞拉利昂",
    en: "+232 Sierra Leone",
  },
  {
    value: "421",
    zh: "+421 斯洛伐克",
    en: "+421 Slovakia",
  },
  {
    value: "386",
    zh: "+386 斯洛文尼亚",
    en: "+386 Slovenia",
  },
  {
    value: "27",
    zh: "+27 南非",
    en: "+27 South Africa",
  },
  {
    value: "82",
    zh: "+82 韩国",
    en: "+82 Korea",
  },
  {
    value: "34",
    zh: "+34 西班牙",
    en: "+34 Spain",
  },
  {
    value: "94",
    zh: "+94 斯里兰卡",
    en: "+94 SriLanka",
  },
  {
    value: "1869",
    zh: "+1869 圣基茨和尼维斯",
    en: "+1869 St Kitts and Nevis",
  },
  {
    value: "1758",
    zh: "+1758 圣卢西亚",
    en: "+1758 St.Lucia",
  },
  {
    value: "1784",
    zh: "+1784 圣文森特",
    en: "+1784 St.Vincent",
  },
  {
    value: "249",
    zh: "+249 苏丹",
    en: "+249 Sudan",
  },
  {
    value: "597",
    zh: "+597 苏里南",
    en: "+597 Suriname",
  },
  {
    value: "268",
    zh: "+268 斯威士兰",
    en: "+268 Swaziland",
  },
  {
    value: "46",
    zh: "+46 瑞典",
    en: "+46 Sweden",
  },
  {
    value: "41",
    zh: "+41 瑞士",
    en: "+41 Switzerland",
  },
  {
    value: "963",
    zh: "+963 叙利亚",
    en: "+963 Syria",
  },
  {
    value: "992",
    zh: "+992 塔吉克斯坦",
    en: "+992 Tajikistan",
  },
  {
    value: "255",
    zh: "+255 坦桑尼亚",
    en: "+255 Tanzania",
  },
  {
    value: "66",
    zh: "+66 泰国",
    en: "+66 Thailand",
  },
  {
    value: "670",
    zh: "+670 东帝汶",
    en: "+670 Timor Leste",
  },
  {
    value: "228",
    zh: "+228 多哥",
    en: "+228 Togo",
  },
  {
    value: "676",
    zh: "+676 汤加",
    en: "+676 Tonga",
  },
  {
    value: "1868",
    zh: "+1868 特立尼达和多巴哥",
    en: "+1868 Trinidad and Tobago",
  },
  {
    value: "216",
    zh: "+216 突尼斯",
    en: "+216 Tunisia",
  },
  {
    value: "90",
    zh: "+90 土耳其",
    en: "+90 Turkey",
  },
  {
    value: "993",
    zh: "+993 土库曼斯坦",
    en: "+993 Turkmenistan",
  },
  {
    value: "1649",
    zh: "+1649 特克斯和凯科斯群岛",
    en: "+1649 Turks and Caicos Islands",
  },
  {
    value: "256",
    zh: "+256 乌干达",
    en: "+256 Uganda",
  },
  {
    value: "380",
    zh: "+380 乌克兰",
    en: "+380 Ukraine",
  },
  {
    value: "971",
    zh: "+971 阿拉伯联合酋长国",
    en: "+971 United Arab Emirates",
  },
  {
    value: "44",
    zh: "+44 英国",
    en: "+44 United Kingdom",
  },
  {
    value: "1",
    zh: "+1 美国",
    en: "+1 USA",
  },
  {
    value: "598",
    zh: "+598 乌拉圭",
    en: "+598 Uruguay",
  },
  {
    value: "998",
    zh: "+998 乌兹别克斯坦",
    en: "+998 Uzbekistan",
  },
  {
    value: "678",
    zh: "+678 瓦努阿图",
    en: "+678 Vanuatu",
  },
  {
    value: "58",
    zh: "+58 委内瑞拉",
    en: "+58 Venezuela",
  },
  {
    value: "84",
    zh: "+84 越南",
    en: "+84 Vietnam",
  },
  {
    value: "1284",
    zh: "+1284 英属维尔京群岛",
    en: "+1284 Virgin Islands, British",
  },
  {
    value: "1340",
    zh: "+1340 美属维尔京群岛",
    en: "+1340 Virgin Islands, U.S.",
  },
  {
    value: "967",
    zh: "+967 也门",
    en: "+967 Yemen",
  },
  {
    value: "260",
    zh: "+260 赞比亚",
    en: "+260 Zambia",
  },
  {
    value: "263",
    zh: "+263 津巴布韦",
    en: "+263 Zimbabwe",
  },
];
// 货币
export const currencyList = [
  {
    value: "SGD",
    zh: "SGD Singapore, Dollars 新币",
    en: "SGD Singapore, Dollars",
  },
  { value: "MYR", zh: "MYR MALAYSIA, RINGGIT 马来西亚林吉特", en: "MYR MALAYSIA, RINGGIT" },
  {
    value: "USD",
    zh: "USD United States of America,Dollars 美金",
    en: "USD United States of America,Dollars",
  },
  {
    value: "CNY",
    zh: "CNY China, Yuan Renminbi 人民币",
    en: "CNY China, Yuan Renminbi",
  },
  {
    value: "HKD",
    zh: "HKD Hong Kong, Dollars 港币",
    en: "HKD Hong Kong, Dollars",
  },
  {
    value: "AFN",
    zh: "AFN AFGHANISTAN, AFGHANI",
    en: "AFN AFGHANISTAN, AFGHANI",
  },
  { value: "ALL", zh: "ALL ALBANIA, LEK", en: "ALL ALBANIA, LEK" },
  { value: "DZD", zh: "DZD ALGERIA, DINARS", en: "DZD ALGERIA, DINARS" },
  { value: "AOA", zh: "AOA ANGOLA, KWANZA", en: "AOA ANGOLA, KWANZA" },
  { value: "ARS", zh: "ARS ARGENTINA, PESOS", en: "ARS ARGENTINA, PESOS" },
  { value: "AMD", zh: "AMD ARENIA, DRAMS", en: "AMD ARENIA, DRAMS" },
  { value: "AWG", zh: "AWG ARUBAN, FLORIN", en: "AWG ARUBAN, FLORIN" },
  { value: "AUD", zh: "AUD AUSTRALIA, DOLLARS", en: "AUD AUSTRALIA, DOLLARS" },
  { value: "AZN", zh: "AZN AZERBAIJAN, MANAT", en: "AZN AZERBAIJAN, MANAT" },
  { value: "BSD", zh: "BSD BAHAMAS, DOLLARS", en: "BSD BAHAMAS, DOLLARS" },
  { value: "BHD", zh: "BHD BAHRAIN, DINARS", en: "BHD BAHRAIN, DINARS" },
  { value: "BDT", zh: "BDT BANGLADESH, TAKA", en: "BDT BANGLADESH, TAKA" },
  { value: "BBD", zh: "BBD BARBADOS, DOLLARS", en: "BBD BARBADOS, DOLLARS" },
  { value: "BYN", zh: "BYN BELARUS, RUBLES", en: "BYN BELARUS, RUBLES" },
  { value: "BYR", zh: "BYR BELARUSIAN, RUBEL", en: "BYR BELARUSIAN, RUBEL" },
  { value: "BZD", zh: "BZD BELIZE, DOLLARS", en: "BZD BELIZE, DOLLARS" },
  { value: "BMD", zh: "BMD BERMUDA, DOLLARS", en: "BMD BERMUDA, DOLLARS" },
  { value: "BTN", zh: "BTN BHUTAN, NGULTRUM", en: "BTN BHUTAN, NGULTRUM" },
  { value: "VEF", zh: "VEF BOLÍVAR, FUERTE", en: "VEF BOLÍVAR, FUERTE" },
  { value: "BOV", zh: "BOV BOLIVIAN, MVDOL", en: "BOV BOLIVIAN, MVDOL" },
  { value: "BOB", zh: "BOB BOLIVIANO, ", en: "BOB BOLIVIANO, " },
  {
    value: "XBA",
    zh: "XBA BOND MARKETS UNITS, EUROPEAN COMPOSITE UNIT",
    en: "XBA BOND MARKETS UNITS, EUROPEAN COMPOSITE UNIT",
  },
  {
    value: "BAM",
    zh: "BAM BOSNIA AND HERZEGOVINA, CONVERTIBLE MARK",
    en: "BAM BOSNIA AND HERZEGOVINA, CONVERTIBLE MARK",
  },
  { value: "BWP", zh: "BWP BOTSWANA, PULAS", en: "BWP BOTSWANA, PULAS" },
  { value: "BRL", zh: "BRL BRAZIL, REAL", en: "BRL BRAZIL, REAL" },
  {
    value: "BND",
    zh: "BND BRUNEI DARUSSALAM, DOLLARS",
    en: "BND BRUNEI DARUSSALAM, DOLLARS",
  },
  { value: "BGN", zh: "BGN BULGARIA, LEV", en: "BGN BULGARIA, LEV" },
  { value: "BIF", zh: "BIF BURUNDI, FRANCS", en: "BIF BURUNDI, FRANCS" },
  { value: "KHR", zh: "KHR CAMBODIA, RIELS", en: "KHR CAMBODIA, RIELS" },
  { value: "CAD", zh: "CAD CANADA, DOLLARS", en: "CAD CANADA, DOLLARS" },
  { value: "CVE", zh: "CVE CAPE VERDE, ESCUDOS", en: "CVE CAPE VERDE, ESCUDOS" },
  {
    value: "KYD",
    zh: "KYD CAYMAN ISLANDS, DOLLARS",
    en: "KYD CAYMAN ISLANDS, DOLLARS",
  },
  { value: "GHS", zh: "GHS CEDI", en: "GHS CEDI" },
  { value: "CLP", zh: "CLP CHILE, PESOS", en: "CLP CHILE, PESOS" },
  { value: "COP", zh: "COP COLOMBIA, PESOS", en: "COP COLOMBIA, PESOS" },
  {
    value: "XAF",
    zh: "XAF COMMUNAUTE FINANCIERE AFRICAINE BEATS, FRANCS",
    en: "XAF COMMUNAUTE FINANCIERE AFRICAINE BEATS, FRANCS",
  },
  {
    value: "XOF",
    zh: "XOF COMMUNAUTE FINANCIERE AFRICAINE FRANCS BCEAO, FRANCS",
    en: "XOF COMMUNAUTE FINANCIERE AFRICAINE FRANCS BCEAO, FRANCS",
  },
  { value: "KMF", zh: "KMF COMOROS, FRANCS", en: "KMF COMOROS, FRANCS" },
  {
    value: "XPF",
    zh: "XPF COMPTOIRS FRANCAIS DU PACIFIQUE, FRANCS",
    en: "XPF COMPTOIRS FRANCAIS DU PACIFIQUE, FRANCS",
  },
  { value: "CDF", zh: "CDF CONGOLESE, FRANCS", en: "CDF CONGOLESE, FRANCS" },
  { value: "NIO", zh: "NIO CÓRDOBA, ORO", en: "NIO CÓRDOBA, ORO" },
  { value: "CRC", zh: "CRC COSTA RICA, COLONES", en: "CRC COSTA RICA, COLONES" },
  { value: "HRK", zh: "HRK CROATIA, KUNA", en: "HRK CROATIA, KUNA" },
  { value: "CUP", zh: "CUP CUBA, PESOS", en: "CUP CUBA, PESOS" },
  { value: "CYP", zh: "CYP CYPRUS, POUNDS", en: "CYP CYPRUS, POUNDS" },
  { value: "CZK", zh: "CZK CZECHIA, KORUNA", en: "CZK CZECHIA, KORUNA" },
  { value: "DKK", zh: "DKK DANISH, KRONE", en: "DKK DANISH, KRONE" },
  { value: "DJF", zh: "DJF DJIBOUTI, FRANCS", en: "DJF DJIBOUTI, FRANCS" },
  {
    value: "DOP",
    zh: "DOP DOMINICAN REPUBLIC, PESOS",
    en: "DOP DOMINICAN REPUBLIC, PESOS",
  },
  {
    value: "XCD",
    zh: "XCD EAST CARIBBEAN, DOLLARS",
    en: "XCD EAST CARIBBEAN, DOLLARS",
  },
  { value: "EGP", zh: "EGP EGYPT, POUNDS", en: "EGP EGYPT, POUNDS" },
  {
    value: "SVC",
    zh: "SVC EL SALVADOR, COLONES",
    en: "SVC EL SALVADOR, COLONES",
  },
  { value: "ERN", zh: "ERN ERITREA, NAKFA", en: "ERN ERITREA, NAKFA" },
  { value: "EEK", zh: "EEK ESTONIA, KROONI", en: "EEK ESTONIA, KROONI" },
  { value: "ETB", zh: "ETB ETHIOPIA, BIRR", en: "ETB ETHIOPIA, BIRR" },
  {
    value: "EUR",
    zh: "EUR EURO MEMBER COUNTRIES, EURO",
    en: "EUR EURO MEMBER COUNTRIES, EURO",
  },
  {
    value: "XBB",
    zh: "XBB EUROPEAN MONETARY UNIT, ",
    en: "XBB EUROPEAN MONETARY UNIT, ",
  },
  {
    value: "XBC",
    zh: "XBC EUROPEAN UNIT OF ACCOUNT, ",
    en: "XBC EUROPEAN UNIT OF ACCOUNT, ",
  },
  {
    value: "XBD",
    zh: "XBD EUROPEAN UNIT OF ACCOUNT, ",
    en: "XBD EUROPEAN UNIT OF ACCOUNT, ",
  },
  {
    value: "FKP",
    zh: "FKP FALKLAND ISLANDS(MALVINAS), POUNDS",
    en: "FKP FALKLAND ISLANDS(MALVINAS), POUNDS",
  },
  { value: "FJD", zh: "FJD FIJI, DOLLARS", en: "FJD FIJI, DOLLARS" },
  { value: "GMD", zh: "GMD GAMBIA, DALASI", en: "GMD GAMBIA, DALASI" },
  { value: "GEL", zh: "GEL GEORGIA, LARI", en: "GEL GEORGIA, LARI" },
  { value: "GHC", zh: "GHC GHANA, CEDIS", en: "GHC GHANA, CEDIS" },
  { value: "GIP", zh: "GIP GIBRALTAR, POUNDS", en: "GIP GIBRALTAR, POUNDS" },
  { value: "XAU", zh: "XAU GOLD, OUNCES", en: "XAU GOLD, OUNCES" },
  { value: "GTQ", zh: "GTQ GUATEALA, QUETZALES", en: "GTQ GUATEALA, QUETZALES" },
  { value: "GGP", zh: "GGP GUERNSEY, POUNDS", en: "GGP GUERNSEY, POUNDS" },
  { value: "GNF", zh: "GNF GUINEA, FRANCS", en: "GNF GUINEA, FRANCS" },
  { value: "GYD", zh: "GYD GUYANA, DOLLARS", en: "GYD GUYANA, DOLLARS" },
  { value: "HTG", zh: "HTG HAITI, GOURDES", en: "HTG HAITI, GOURDES" },
  { value: "HNL", zh: "HNL HONDURAS, LEMPIRAS", en: "HNL HONDURAS, LEMPIRAS" },
  { value: "HUF", zh: "HUF HUNGARY, FORINT", en: "HUF HUNGARY, FORINT" },
  { value: "ISK", zh: "ISK ICELANDIC, KRONA", en: "ISK ICELANDIC, KRONA" },
  { value: "INR", zh: "INR INDIA, REPEES", en: "INR INDIA, REPEES" },
  { value: "IDR", zh: "IDR INDONESIA, RUPIAHS", en: "IDR INDONESIA, RUPIAHS" },
  {
    value: "XDR",
    zh: "XDR INTERNATIONAL MONETARY FUND(IMF), SPECIAL DRAWING RIGHTS",
    en: "XDR INTERNATIONAL MONETARY FUND(IMF), SPECIAL DRAWING RIGHTS",
  },
  { value: "IRR", zh: "IRR IRAN, RIALS", en: "IRR IRAN, RIALS" },
  { value: "IQD", zh: "IQD IRAQ, DINARS", en: "IQD IRAQ, DINARS" },
  { value: "IMP", zh: "IMP ISLE OF MAN, POUNDS", en: "IMP ISLE OF MAN, POUNDS" },
  { value: "ILS", zh: "ILS ISRAEL, NEW SHEKELS", en: "ILS ISRAEL, NEW SHEKELS" },
  { value: "JMD", zh: "JMD JAMAICA, DOLLARS", en: "JMD JAMAICA, DOLLARS" },
  { value: "JPY", zh: "JPY JAPAN, YEN", en: "JPY JAPAN, YEN" },
  { value: "JEP", zh: "JEP JERSEY, POUNDS", en: "JEP JERSEY, POUNDS" },
  { value: "JOD", zh: "JOD JORDAN, DINARS", en: "JOD JORDAN, DINARS" },
  { value: "KZT", zh: "KZT KAZAKHSTAN, TENGE", en: "KZT KAZAKHSTAN, TENGE" },
  { value: "KES", zh: "KES KENYA, SHILLINGS", en: "KES KENYA, SHILLINGS" },
  { value: "KRI", zh: "KRI KIRIBATI, DOLLAR", en: "KRI KIRIBATI, DOLLAR" },
  { value: "KPW", zh: "KPW KOREA(NORTH), WON", en: "KPW KOREA(NORTH), WON" },
  { value: "KRW", zh: "KRW KOREA(SOUTH), WON", en: "KRW KOREA(SOUTH), WON" },
  { value: "KWD", zh: "KWD KUWAIT, DINARS", en: "KWD KUWAIT, DINARS" },
  { value: "KGS", zh: "KGS KYRGYZSTAN, SOMS", en: "KGS KYRGYZSTAN, SOMS" },
  { value: "LAK", zh: "LAK LAOS, KIPS", en: "LAK LAOS, KIPS" },
  { value: "LVL", zh: "LVL LATVIAN, LATS", en: "LVL LATVIAN, LATS" },
  { value: "LBP", zh: "LBP LEBANON, POUNDS", en: "LBP LEBANON, POUNDS" },
  { value: "LSL", zh: "LSL LESOTHO, LOTI", en: "LSL LESOTHO, LOTI" },
  { value: "LRD", zh: "LRD LIBERIA, DOLLARS", en: "LRD LIBERIA, DOLLARS" },
  { value: "LYD", zh: "LYD LIBYA, DINARS", en: "LYD LIBYA, DINARS" },
  { value: "LTL", zh: "LTL LITHUANIAN, LITAS", en: "LTL LITHUANIAN, LITAS" },
  { value: "MOP", zh: "MOP MACAU, PATACAS", en: "MOP MACAU, PATACAS" },
  { value: "MKD", zh: "MKD MACEDONIA, DENARS", en: "MKD MACEDONIA, DENARS" },
  { value: "MGA", zh: "MGA MADAGASCAR, ARIARY", en: "MGA MADAGASCAR, ARIARY" },
  { value: "MWK", zh: "MWK MALAWI, KWACHAS", en: "MWK MALAWI, KWACHAS" },
  {
    value: "MVR",
    zh: "MVR MALDIVES (MALDIVE ISLANDS), RUFIYAA",
    en: "MVR MALDIVES (MALDIVE ISLANDS), RUFIYAA",
  },
  { value: "MTL", zh: "MTL MALTA, LIRI", en: "MTL MALTA, LIRI" },
  {
    value: "MRO",
    zh: "MRO MAURITANIA, OUGUIYAS",
    en: "MRO MAURITANIA, OUGUIYAS",
  },
  {
    value: "MRU",
    zh: "MRU MAURITANIA, OUGUIYAS",
    en: "MRU MAURITANIA, OUGUIYAS",
  },
  { value: "MUR", zh: "MUR MAURITIUS, RUPEE", en: "MUR MAURITIUS, RUPEE" },
  {
    value: "MXV",
    zh: "MXV MEXICAN, UNIDAD DE INVERSION(UDI)",
    en: "MXV MEXICAN, UNIDAD DE INVERSION(UDI)",
  },
  {
    value: "MXN",
    zh: "MXN MEXICO, MEXICAN PESO",
    en: "MXN MEXICO, MEXICAN PESO",
  },
  { value: "MDL", zh: "MDL MOLDOVA, LEU", en: "MDL MOLDOVA, LEU" },
  { value: "MNT", zh: "MNT MONGOLIA, TUGRIKS", en: "MNT MONGOLIA, TUGRIKS" },
  { value: "MAD", zh: "MAD MOROCCO, DIRHAMS", en: "MAD MOROCCO, DIRHAMS" },
  {
    value: "MZN",
    zh: "MZN MOZAMBIQUE, METICALS",
    en: "MZN MOZAMBIQUE, METICALS",
  },
  {
    value: "MMK",
    zh: "MMK MYANMAR(BURMA), KYATS",
    en: "MMK MYANMAR(BURMA), KYATS",
  },
  { value: "NAD", zh: "NAD NAMIBIA, DOLLARS", en: "NAD NAMIBIA, DOLLARS" },
  {
    value: "NPR",
    zh: "NPR NEPAL, NEPALESE RUPEE",
    en: "NPR NEPAL, NEPALESE RUPEE",
  },
  {
    value: "ANG",
    zh: "ANG NETHERLANDS ANTILLES, GUILDERS",
    en: "ANG NETHERLANDS ANTILLES, GUILDERS",
  },
  {
    value: "NZD",
    zh: "NZD NEW ZEALAND, DOLLARS",
    en: "NZD NEW ZEALAND, DOLLARS",
  },
  { value: "NGN", zh: "NGN NIGERIA, NAIRAS", en: "NGN NIGERIA, NAIRAS" },
  { value: "XXX", zh: "XXX NO CURRENCY, ", en: "XXX NO CURRENCY, " },
  { value: "NOK", zh: "NOK NORWEGIAN, KRONE", en: "NOK NORWEGIAN, KRONE" },
  { value: "OMR", zh: "OMR OMAN, RIALS", en: "OMR OMAN, RIALS" },
  { value: "OTH", zh: "OTH OTHERS", en: "OTH OTHERS" },
  { value: "PKR", zh: "PKR PAKISTAN, RUPEES", en: "PKR PAKISTAN, RUPEES" },
  { value: "XPD", zh: "XPD PALLADIUM, OUNCES", en: "XPD PALLADIUM, OUNCES" },
  { value: "PAB", zh: "PAB PANAMA, BALBOA", en: "PAB PANAMA, BALBOA" },
  {
    value: "PGK",
    zh: "PGK PAPUA NEW GUINEA, KINA",
    en: "PGK PAPUA NEW GUINEA, KINA",
  },
  { value: "PYG", zh: "PYG PARAGUAY, GUARANÍ", en: "PYG PARAGUAY, GUARANÍ" },
  { value: "PEN", zh: "PEN PERU, NUEVO SOLES", en: "PEN PERU, NUEVO SOLES" },
  { value: "CUC", zh: "CUC PESO, CONVERTIBLE", en: "CUC PESO, CONVERTIBLE" },
  { value: "PHP", zh: "PHP PHILIPPINES, PESOS", en: "PHP PHILIPPINES, PESOS" },
  { value: "XPT", zh: "XPT PLATINUM, OUNCES", en: "XPT PLATINUM, OUNCES" },
  { value: "PLN", zh: "PLN POLISH, ZLOTY", en: "PLN POLISH, ZLOTY" },
  { value: "QAR", zh: "QAR QATAR, RIALS", en: "QAR QATAR, RIALS" },
  { value: "RON", zh: "RON ROMANIA, LEU", en: "RON ROMANIA, LEU" },
  { value: "RUB", zh: "RUB RUSSIA, REBELS", en: "RUB RUSSIA, REBELS" },
  { value: "RWF", zh: "RWF RWANDA, FRANCS", en: "RWF RWANDA, FRANCS" },
  {
    value: "SHP",
    zh: "SHP SAINT HELENA, POUNDS",
    en: "SHP SAINT HELENA, POUNDS",
  },
  { value: "WST", zh: "WST SAMOA, TALA", en: "WST SAMOA, TALA" },
  {
    value: "STD",
    zh: "STD SAO TOME AND PRINCIPE, ",
    en: "STD SAO TOME AND PRINCIPE, ",
  },
  {
    value: "STN",
    zh: "STN SAO TOME AND PRINCIPE, DOBRAS",
    en: "STN SAO TOME AND PRINCIPE, DOBRAS",
  },
  {
    value: "SAR",
    zh: "SAR SAUDI ARABIA, RIYALS",
    en: "SAR SAUDI ARABIA, RIYALS",
  },
  { value: "SPL", zh: "SPL SEBORGA, LUIGINI", en: "SPL SEBORGA, LUIGINI" },
  { value: "RSD", zh: "RSD SERBIA, DINARS", en: "RSD SERBIA, DINARS" },
  { value: "SCR", zh: "SCR SEYCHELLES, RUPEES", en: "SCR SEYCHELLES, RUPEES" },
  {
    value: "SLL",
    zh: "SLL SIERRA LEONE, LEONES",
    en: "SLL SIERRA LEONE, LEONES",
  },
  { value: "XAG", zh: "XAG SILVER, OUNCES", en: "XAG SILVER, OUNCES" },
  { value: "SKK", zh: "SKK SLOVAKIA, KORUNY", en: "SKK SLOVAKIA, KORUNY" },
  {
    value: "SBD",
    zh: "SBD SOLOMON ISLANDS, DOLLARS",
    en: "SBD SOLOMON ISLANDS, DOLLARS",
  },
  { value: "SOS", zh: "SOS SOMALIA, SHILLINGS", en: "SOS SOMALIA, SHILLINGS" },
  {
    value: "SLS",
    zh: "SLS SOMALILAND, SHILLING",
    en: "SLS SOMALILAND, SHILLING",
  },
  { value: "ZAR", zh: "ZAR SOUTH AFRICA, RAND", en: "ZAR SOUTH AFRICA, RAND" },
  {
    value: "SSP",
    zh: "SSP SOUTH SUDANESE, POUND",
    en: "SSP SOUTH SUDANESE, POUND",
  },
  { value: "LKR", zh: "LKR SRI LANKA, RUPEES", en: "LKR SRI LANKA, RUPEES" },
  { value: "SDD", zh: "SDD SUDAN, POUND", en: "SDD SUDAN, POUND" },
  { value: "SDG", zh: "SDG SUDANESE, POUND", en: "SDG SUDANESE, POUND" },
  { value: "SRD", zh: "SRD SURINAME, DOLLARS", en: "SRD SURINAME, DOLLARS" },
  { value: "SZL", zh: "SZL SWAZI, LILANGENI", en: "SZL SWAZI, LILANGENI" },
  { value: "SEK", zh: "SEK SWEDEN, KRONOR", en: "SEK SWEDEN, KRONOR" },
  { value: "CHF", zh: "CHF SWITZERLAND, FRANCS", en: "CHF SWITZERLAND, FRANCS" },
  { value: "SYP", zh: "SYP SYRIAN, POUND", en: "SYP SYRIAN, POUND" },
  { value: "TWD", zh: "TWD TAIWAN, NEW DOLLAR", en: "TWD TAIWAN, NEW DOLLAR" },
  { value: "TJS", zh: "TJS TAJIKISTAN, SOMONI", en: "TJS TAJIKISTAN, SOMONI" },
  { value: "TZS", zh: "TZS TANZANIA, SHILLINGS", en: "TZS TANZANIA, SHILLINGS" },
  { value: "THB", zh: "THB THAILAND, BAHT", en: "THB THAILAND, BAHT" },
  { value: "TOP", zh: "TOP TONGA, PA'ANGA", en: "TOP TONGA, PA'ANGA" },
  {
    value: "PRB",
    zh: "PRB TRANSNISTRIAN, RUBLE",
    en: "PRB TRANSNISTRIAN, RUBLE",
  },
  {
    value: "TTD",
    zh: "TTD TRINIDAD AND TOBAGO, DOLLARS",
    en: "TTD TRINIDAD AND TOBAGO, DOLLARS",
  },
  { value: "TND", zh: "TND TUNISIA, DINARS", en: "TND TUNISIA, DINARS" },
  { value: "TRY", zh: "TRY TURKISH, LIRA", en: "TRY TURKISH, LIRA" },
  {
    value: "TMT",
    zh: "TMT TURKMENISTAN, NEW MANAT",
    en: "TMT TURKMENISTAN, NEW MANAT",
  },
  {
    value: "TMM",
    zh: "TMM TURKMENISTAN, MANATS",
    en: "TMM TURKMENISTAN, MANATS",
  },
  {
    value: "TVD",
    zh: "TVD TUVALU, TUVALUAN DOLLARS",
    en: "TVD TUVALU, TUVALUAN DOLLARS",
  },
  { value: "UGX", zh: "UGX UGANDA, SHILLINGS", en: "UGX UGANDA, SHILLINGS" },
  { value: "XFU", zh: "XFU UIC, FRANC", en: "XFU UIC, FRANC" },
  { value: "UAH", zh: "UAH UKRAINE, HRYWNJA", en: "UAH UKRAINE, HRYWNJA" },
  {
    value: "COU",
    zh: "COU UNIDAD, DE VALOR REAL",
    en: "COU UNIDAD, DE VALOR REAL",
  },
  {
    value: "CLF",
    zh: "CLF UNIDADES, DE FOMENTO",
    en: "CLF UNIDADES, DE FOMENTO",
  },
  {
    value: "AED",
    zh: "AED UNITED ARAB EMIRATES, DIRHAMS",
    en: "AED UNITED ARAB EMIRATES, DIRHAMS",
  },
  {
    value: "GBP",
    zh: "GBP UNITED KINGDOM, POUNDS",
    en: "GBP UNITED KINGDOM, POUNDS",
  },
  {
    value: "USN",
    zh: "USN UNITED STATES DOLLAR(NEXT DAY), FUNDS CODE",
    en: "USN UNITED STATES DOLLAR(NEXT DAY), FUNDS CODE",
  },
  {
    value: "USS",
    zh: "USS UNITED STATES DOLLAR(SAME DAY), FUNDS CODE",
    en: "USS UNITED STATES DOLLAR(SAME DAY), FUNDS CODE",
  },
  { value: "UYU", zh: "UYU URUGUAY, PESOS", en: "UYU URUGUAY, PESOS" },
  {
    value: "UYW",
    zh: "UYW URUGUAY, UNIDAD PREVISONAL",
    en: "UYW URUGUAY, UNIDAD PREVISONAL",
  },
  {
    value: "UYI",
    zh: "UYI URUGUAY PESO EN UNIDADES INDEXADSA (URUIURUI) (FUNDS CODE)",
    en: "UYI URUGUAY PESO EN UNIDADES INDEXADSA (URUIURUI) (FUNDS CODE)",
  },
  { value: "UZS", zh: "UZS UZBEKISTAN, SUMS", en: "UZS UZBEKISTAN, SUMS" },
  { value: "VUV", zh: "VUV VANUATU, VATU", en: "VUV VANUATU, VATU" },
  {
    value: "VEB",
    zh: "VEB VENEZUELA, BOLIVARES",
    en: "VEB VENEZUELA, BOLIVARES",
  },
  {
    value: "VES",
    zh: "VES VENEZUELA(BOLIVARIAN REPUBLIC OF), BOLIVAR SOBERANO",
    en: "VES VENEZUELA(BOLIVARIAN REPUBLIC OF), BOLIVAR SOBERANO",
  },
  { value: "VND", zh: "VND VIETNAM, DONG", en: "VND VIETNAM, DONG" },
  { value: "CHE", zh: "CHE WIR, EURO", en: "CHE WIR, EURO" },
  { value: "CHW", zh: "CHW WIR, FRANC", en: "CHW WIR, FRANC" },
  { value: "YER", zh: "YER YEMEN, RIALS", en: "YER YEMEN, RIALS" },
  { value: "ZMK", zh: "ZMK ZAMBIA, KWACHA", en: "ZMK ZAMBIA, KWACHA" },
];
